import { Typography } from '@mui/material';
import { useViewContractsState } from 'customer-management/customer-details/view-contracts/state/view-contracts-state';
import { UseTableCellProps } from 'react-table';
import { FormattedNumber, MoneyOrPercentField } from 'shared/controls';

export function EditableTierColumn<T extends object>({
  value,
  row: { index, original },
  column: { id, rules, section, percent },
}: UseTableCellProps<T>) {
  const state = useViewContractsState();
  const editMode = state.editMode.get();

  if (editMode) {
    return (
      <MoneyOrPercentField
        index={index}
        original={original}
        id={id}
        rules={rules}
        percent={percent}
        section={section}
        decimalScale={percent ? 3 : 2}
      />
    );
  }
  return percent ? (
    <Typography variant='body2'>
      <FormattedNumber value={Number(value * 100)} suffix='%' fixedDecimalScale decimalScale={3} />
    </Typography>
  ) : (
    <Typography variant='body2'>
      <FormattedNumber value={value} prefix='$' fixedDecimalScale decimalScale={2} />
    </Typography>
  );
}
